import { cloneElement, FC, JSX } from 'react';
import { Tooltip } from '@silverfort/sf-components';
import { TooltipLockedFeatureDisplayConfig } from './types';

interface LockedFeatureTooltipProps {
    tooltipProps: TooltipLockedFeatureDisplayConfig['tooltipProps'];
    children: JSX.Element;
    className?: string;
}

const LockedFeatureTooltip: FC<LockedFeatureTooltipProps> = ({ tooltipProps, children, className }) => {
    const { description, onGetAccessClick, title } = tooltipProps;
    return (
        <Tooltip
            title={title}
            buttonTitle="Get Access"
            onButtonClick={onGetAccessClick}
            description={description}
            className={className}>
            {cloneElement(children, {
                className: [children.props?.className, 'pointer-events-none'].filter(Boolean).join(' '),
                disabled: true
            })}
        </Tooltip>
    );
};

export default LockedFeatureTooltip;
